<template>
  <div>
    <Navbar/>
    <b-container class="mt-3">
      <b-row class="text-left">
        <b-col cols="8">
          <h4>My Cart: </h4>
          <div v-if="carts.length === 0">
            <h5>Opppssss... Your cart is empty</h5>
            <router-link to="/"><span class="btn btn-success"><b-icon-cart4/> Continue Shopping</span></router-link>
          </div>
          <div v-else>
            <div v-for="cart in carts" :key="cart.id">
              <CartList :cart="cart"/>
            </div>
          </div>
        </b-col>
        <b-col>
          <Summary :carts="carts"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import CartList from '@/components/CartList.vue'
import Summary from '@/components/Summary.vue'

export default {
  name: 'Cart',
  computed: {
    carts () {
      return this.$store.state.carts
    }
  },
  components: {
    Navbar, CartList, Summary
  },
  methods: {
    fetchAllCarts () {
      this.$store.dispatch('fetchAllCarts')
    }
  },
  created () {
    this.fetchAllCarts()
  }
}
</script>

<style>

</style>
